<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,785.33l4.33,4.33l-4.33,4.33l-4.33-4.33L0.5,785.33z M6.17,791l4.33,4.33l-4.33,4.33l-4.06-4.06l0,0l-0.28-0.27
	L6.17,791z M-5.17,791l4.33,4.33l-0.27,0.27l0,0l-4.06,4.06l-4.33-4.33L-5.17,791z"/>
</svg>

</template>